/* ===== Colibrí Zoom – desktop only (v2, clamp bordes) ===== */
(function () {
  "use strict";

  var MIN_WIDTH = 768;   // sólo PC/tablet horizontal
  var SCALE     = 1.6;   // nivel de zoom pedido
  var result, boundImg, bigImg;

  function $(sel, root){ return (root || document).querySelector(sel); }
  function on(el, ev, fn, opt){ el && el.addEventListener(ev, fn, opt||false); }

  // Encuentra la imagen visible más grande del área principal
  function findMainImage(){
    var candidates = document.querySelectorAll(
      'main img[src*="/products/"], main img[src*="/cdn/shop/"], .product img, .rimage__image'
    );
    var best = null, bestArea = 0;
    candidates.forEach(function(img){
      var r = img.getBoundingClientRect();
      var area = (r.width * r.height);
      if (r.width > 300 && r.height > 200 && area > bestArea && isInViewport(r)) {
        best = img; bestArea = area;
      }
    });
    return best;
  }

  function isInViewport(rect){
    return rect.width > 0 && rect.height > 0 &&
           rect.bottom > 0 && rect.right > 0 &&
           rect.top < window.innerHeight && rect.left < window.innerWidth;
  }

  function ensureResult(){
    if (!result){
      result = document.createElement('div');
      result.id = 'rz-zoom-result';
      result.className = 'rz-zoom-result';
      document.body.appendChild(result); // fuera del layout del tema
    }
    return result;
  }

  function loadBigFor(img){
    if (bigImg && bigImg.src === (img.currentSrc || img.src)) return bigImg;
    bigImg = new Image();
    bigImg.src = img.currentSrc || img.src;
    bigImg.onload = function(){ updateBgSize(); };
    updateBgSize(); // por si ya está en caché
    return bigImg;
  }

  function updateBgSize(){
    if (!result || !bigImg || !bigImg.naturalWidth) return;
    result.style.backgroundImage = "url('" + bigImg.src.replace(/'/g,"\\'") + "')";
    result.style.backgroundSize = (bigImg.naturalWidth * SCALE) + "px " +
                                  (bigImg.naturalHeight * SCALE) + "px";
  }

  function placeResultBeside(img){
    if (!result) return;
    var r = img.getBoundingClientRect();
    // tamaño del panel según alto de la imagen (máx 420, min 280)
    var size = Math.min(420, Math.max(280, r.height));
    result.style.width  = size + "px";
    result.style.height = size + "px";

    var gap = 16;
    var leftRightSpace = window.innerWidth - r.right - gap;
    var leftPos;

    if (leftRightSpace >= size) {
      // cabe a la derecha
      leftPos = r.right + gap;
    } else {
      // a la izquierda
      leftPos = Math.max(8, r.left - size - gap);
    }
    // top dentro de la ventana
    var topPos = Math.max(8, Math.min(r.top, window.innerHeight - size - 8));

    result.style.left = leftPos + "px";
    result.style.top  = topPos  + "px";
  }

  function onMove(e){
    if (!boundImg || window.innerWidth < MIN_WIDTH) return;

    // si cambió el src (por miniatura/variante), recargamos la grande
    if (bigImg && bigImg.src !== (boundImg.currentSrc || boundImg.src)) {
      loadBigFor(boundImg);
    }

    var rect = boundImg.getBoundingClientRect();
    var clientX = (e.touches ? e.touches[0].clientX : e.clientX);
    var clientY = (e.touches ? e.touches[0].clientY : e.clientY);
    var x = clientX - rect.left;
    var y = clientY - rect.top;

    if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
      result && result.classList.remove('is-visible');
      return;
    }

    ensureResult();
    loadBigFor(boundImg);
    placeResultBeside(boundImg);
    result.classList.add('is-visible');

    // porcentaje relativo dentro de la imagen
    var cx = x / rect.width;
    var cy = y / rect.height;

    if (bigImg && bigImg.naturalWidth) {
      var rx = (-cx * bigImg.naturalWidth  * SCALE) + (result.clientWidth  / 2);
      var ry = (-cy * bigImg.naturalHeight * SCALE) + (result.clientHeight / 2);

      // === CLAMP para evitar bordes blancos ===
      var maxX = 0;
      var maxY = 0;
      var minX = -(bigImg.naturalWidth  * SCALE - result.clientWidth);
      var minY = -(bigImg.naturalHeight * SCALE - result.clientHeight);
      if (rx > maxX) rx = maxX;
      if (ry > maxY) ry = maxY;
      if (rx < minX) rx = minX;
      if (ry < minY) ry = minY;
      // ========================================

      result.style.backgroundPosition = rx + "px " + ry + "px";
    }
  }

  function onLeave(){
    result && result.classList.remove('is-visible');
  }

  function bind(img){
    if (!img || img.dataset.rzBound === "1") return;
    img.dataset.rzBound = "1";
    boundImg = img;

    // listeners en el contenedor más cercano si existe, o en la propia imagen
    var area = img.closest('.product-media_image, .product_media, .rimage-wrapper, .media') || img;
    on(area, 'mousemove', onMove);
    on(area, 'mouseleave', onLeave);
  }

  function init(){
    if (window.innerWidth < MIN_WIDTH) return; // solo PC
    var img = findMainImage();
    if (img) { bind(img); }
  }

  // re-init cuando cambia el DOM (miniaturas/variantes/AJAX)
  var root = $('#MainContent') || document.body;
  if (root) {
    var mo = new MutationObserver(function(){
      setTimeout(init, 40);
    });
    mo.observe(root, {childList:true, subtree:true, attributes:true, attributeFilter:['src','srcset','class']});
  }

  on(document, 'DOMContentLoaded', init);
  on(window,   'load',         init);
  on(window,   'resize',       function(){ if (result && boundImg) placeResultBeside(boundImg); });
  on(window,   'scroll',       function(){ if (result && boundImg) placeResultBeside(boundImg); });
})();